function googleearchdata(searchid) {
    var validateSearch = 1;
    var pagedata = document.getElementById(searchid).value.trim();
    if (pagedata.trim() == "" || pagedata.match("<[^>]*script")) {
        $("#"+searchid).closest(".form-group").addClass("error");
        document.getElementById(searchid).focus();
        validateSearch = 0;
    }
    if (validateSearch == 0) {
        return false;
    } else {
        if (searchid == "mobmbsearch") {
            var setId = "mobmbsearch-btn";
            var searchicon = "mobmbsearch-search";
            var loadericon1 = "mobmbsearch1-loader";
            var loadericon2 = "mobmbsearch2-loader";
        } else if (searchid == "mbsearch") {
            var setId = "mbsearch-btn";
            var searchicon = "mbsearch-search";
            var loadericon = "mbsearch-loader";
        }

        $("#" + setId)
            .find("#" + searchicon)
            .addClass("hide");
            
        if (searchid == "mobmbsearch") {
            $("#" + setId)
            .find("#" + loadericon1)
            .removeClass("hide");
            $("#" + setId)
            .find("#" + loadericon2)
            .removeClass("hide");
        }
        else if(searchid == "mbsearch"){
            $("#" + setId)
            .find("#" + loadericon)
            .removeClass("hide");
        }
        

        $("#"+searchid).closest(".form-group").removeClass("error");
        /** set cookie for recent items */
        var recent = getCookie("recentSearch");
        if (recent) {
            var recentItems = JSON.parse(recent);
            var exist = recentItems.includes(pagedata);
            if (!exist) {
                recentItems.push(pagedata);
                var json_str = JSON.stringify(recentItems);
                setCookie("recentSearch", json_str, 1);
            }
        } else {
            var recentItems = [];
            recentItems.push(pagedata);
            var json_str = JSON.stringify(recentItems);
            setCookie("recentSearch", json_str, 1);
        }
        return true;
    }
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toGMTString();
    console.log(expires);
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$(document).on("click touchstart",".removeSearch",function(event){
    event.stopPropagation();
    document.cookie = "recentSearch=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    $(".recent-ul").remove();
    //$(".removeSearch").remove();
    $(".recentSearch").remove();
});

$(document).on("click touchstart", ".removeSearchItem", function(event){
    event.stopPropagation();
    var val = $.trim($(this).closest(".recentItem").text());
    //console.log(val);
    if(val != ""){
        var recent = getCookie("recentSearch");
        if (recent) {
            var recentItems = JSON.parse(recent);
            var exist = recentItems.includes(val);
            if (exist) {
                recentItems = removeA(recentItems, val);
                if(recentItems.length == 0){
                    document.cookie = "recentSearch=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    $(".recent-ul").remove();
                    $(".recentSearch").remove();
                }
                else{
                    var json_str = JSON.stringify(recentItems);
                    setCookie("recentSearch", json_str, 1);
                }
                
            }
        }
    }
    $(this).closest(".recentItem").remove();

});

function removeA(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax= arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}

$(document).on("click", ".backTransparent", function(event){
    event.stopPropagation();
    $(".search").removeClass("show");
});

$(document).on("focusin", ".search__field .form-control", function() {
     $(".search-dropdown").removeClass("hide");
});

$(document).on("click touchstart", ".recentItem", function(event) {
    event.stopPropagation();
    var val = $.trim($(this).text());
    if (val != "") {
        $("#mobmbsearch,#mbsearch").val(val);
        $(".search-dropdown").addClass("hide");
    }
});

$('body').on('click touchstart', function (event) {
    // console.log(event);
    // console.log(event.target.id);

    if (event.target.id == "mobmbsearch") {
        return;
    } else if (event.target.id == "mbsearch") {
        return;
    }else if (event.target.className == "closeIcon removeSearchItem") {
        return;
    }else if (event.target.className == "text-right removeSearch") {
        return;
    } else {
        if ($(".search-dropdown").length) {
            if (!$(event.target).closest(".search-dropdown").length) {
                $(".search-dropdown").addClass("hide");
            }
        }
    }
});


window.googleearchdata = googleearchdata;
window.setCookie = setCookie;
window.getCookie = getCookie;
window.removeA = removeA;